<script lang="ts">
  import { useToast } from '../composables/useToast'

  const { toasts, dismiss } = useToast()
</script>

<div class="toaster" aria-live="polite" aria-atomic="true">
  {#each $toasts as toast (toast.id)}
    <button type="button" class="toast toast--{toast.level}" onclick={() => dismiss(toast.id)}>
      {toast.message}
    </button>
  {/each}
</div>

<style lang="scss">
  @use '../assets/styles/variables' as v;

  .toaster {
    position: fixed;
    bottom: v.$space-lg;
    right: v.$space-lg;
    display: flex;
    flex-direction: column;
    gap: v.$space-sm;
    z-index: 1000;
    pointer-events: none;
  }

  .toast {
    pointer-events: auto;
    padding: v.$space-sm v.$space-md;
    border-radius: v.$radius-md;
    border: 1px solid v.$color-border;
    background: v.$color-surface-elevated;
    font: inherit;
    text-align: left;
    cursor: pointer;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
    max-width: 360px;

    &--success {
      background: v.$color-success-bg;
      color: v.$color-success-fg;
      border-color: v.$color-success-fg;
    }

    &--error {
      background: v.$color-danger-bg;
      color: v.$color-danger-fg;
      border-color: v.$color-danger-fg;
    }

    &--warning {
      background: v.$color-warning-bg;
      color: v.$color-warning-fg;
      border-color: v.$color-warning-fg;
    }

    &--info {
      color: v.$color-text;
    }
  }
</style>
